<template>
    <span :class="statusSpecificConfig.class">
        <i :class="statusSpecificConfig.icon"></i> {{ statusSpecificConfig.text }}
    </span>
</template>

<script>
import OrderStatuses from './consts/order_statuses';
export default {
    name: 'OrderStatusLabel',

    props: {
        orderStatus: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            config: {
                [OrderStatuses.ORDER_STATUS_CANCELLED]: {
                    class: 'text-danger',
                    icon: 'fa fa-ban',
                    text: 'Cancelled',
                },
                [OrderStatuses.ORDER_STATUS_COMPLETE]: {
                    class: 'text-success',
                    icon: 'far fa-check-circle',
                    text: 'Ordered',
                },
                [OrderStatuses.ORDER_STATUS_PENDING]: {
                    class: 'text-warning',
                    icon: 'fa fa-clock',
                    text: 'Pending',
                },
                [OrderStatuses.ORDER_STATUS_PROCESSED]: {
                    class: 'text-success',
                    icon: 'fas fa-check-circle',
                    text: 'Processed',
                },
                [OrderStatuses.ORDER_STATUS_RETURNED]: {
                    class: 'text-danger',
                    icon: 'fa fa-ban',
                    text: 'Returned',
                },
            },
        }
    },

    computed: {
        statusSpecificConfig() {
            return this.config[this.orderStatus];
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Orders/OrderStatusLabel.vue